export enum Entity {
  PRODUCTS = 'products',
  LOCATIONS = 'locations',
  STOCK = 'stock',
  ORDERS = 'orders',
  CUSTOMERS = 'customers',
  SUPPLIERS = 'suppliers',
  PURCHASE_ORDERS = 'purchase_orders',
  TAGS = 'tags',
  BILLING = 'billing',
}
